import { OperationalAPIService } from "@app/services/Methods/api";
import { PostSelectedProductResponse, SelectedProductResponse } from "@app/types/API.types";
import { SelectedProducts } from "@app/types/selectProduct.types";

export const getSelectedProducts = () =>
    OperationalAPIService.get<SelectedProductResponse>("/products/GetProductDetails");

export const addSelectedProducts = (products: SelectedProducts) =>
    OperationalAPIService.post<PostSelectedProductResponse>("/products/SelectProducts", products);
